import React from 'react'
import { MobileStateActionType, useHeaderContext } from './header-context'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Icon from '@dustin-web/microsite-components/src/icon'

const MobileHeaderBreadcrumb = () => {
  const { mobile, dispatchMobile } = useHeaderContext()
  const { translate } = useTranslations()

  const handleClick = () => {
    if (mobile.breadcrumbs) {
      const lastBreadcrumb = mobile.breadcrumbs.length - 1
      if (mobile.breadcrumbs.length > 1) {
        mobile.breadcrumbs[lastBreadcrumb]?.action()
        dispatchMobile({
          type: MobileStateActionType.SET_BREADCRUMBS,
          payload: { breadcrumbs: mobile.breadcrumbs.slice(0, lastBreadcrumb) },
        })
      } else {
        mobile.breadcrumbs[lastBreadcrumb]?.action()
        dispatchMobile({
          type: MobileStateActionType.SET_BREADCRUMBS,
          payload: { breadcrumbs: null },
        })
      }
    }
  }

  return (
    mobile.breadcrumbs && (
      <div className="c-mobile-header-breadcrumb">
        <button
          className="c-mobile-header-breadcrumb__btn button-stripped u-mb-0 a-fade-in "
          onClick={handleClick}>
          <Icon name={'arrow-left-small'} className="i-26 c-mobile-header-breadcrumb__icon" />
          <span className="u-pl-16 u-fs-16">{translate('Back')}</span>
        </button>
      </div>
    )
  )
}

export default MobileHeaderBreadcrumb
